/* ============================================================
 * RISENAUT · bg-layer render engine
 * Copyright (c) 2026 RISENAUT (risenaut.com). All rights reserved.
 * Proprietary and confidential. Unauthorized copying or reuse prohibited.
 * Build ref: RSN-BGL-0001 · origin: risenaut.com
 * ============================================================ */
(function(){
  try{
    console.log('%cRISENAUT','color:#4DD0FF;font-weight:700;font-family:monospace;font-size:12px',
      '· bg-layer · (c) 2026 risenaut.com · RSN-BGL-0001 · all constants verified');
  }catch(e){}
  /* rsn-canary:RSN-BGL-0001-9f3c-do-not-remove-origin-risenaut-com */
  var c=document.getElementById('bg-canvas'); if(!c) return;
  var x=c.getContext('2d');
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var w,h,dpr,stars=[],nebs=[],bodies=[],mx=0,my=0,tx=0,ty=0,scroll=window.scrollY||0,tScroll=scroll;

  function build(){
    dpr=Math.min(devicePixelRatio||1,2);
    w=c.width=innerWidth*dpr; h=c.height=innerHeight*dpr;
    c.style.width=innerWidth+'px'; c.style.height=innerHeight+'px';
    var vh=innerHeight*dpr;
    var n=Math.min(560,Math.floor(innerWidth*innerHeight/3400)); stars=[];
    for(var i=0;i<n;i++){var depth=Math.pow(Math.random(),1.5);
      stars.push({x:Math.random()*w,y:Math.random()*(h*2.2),depth:depth,
        r:(depth*1.7+0.25)*dpr,base:.18+depth*.7,tw:Math.random()*6.28,
        tws:.5+Math.random()*1.7,cyan:Math.random()<.10});}
    nebs=[{x:w*.5,y:vh*.6,r:Math.max(w,h)*.6,col:[40,90,150],a:.05,p:.15},
          {x:w*.2,y:vh*1.4,r:Math.max(w,h)*.5,col:[90,120,210],a:.05,p:.2}];
    bodies=[
      {type:'neptune',wy:vh*0.42,xf:0.82,r:Math.min(w,h)*0.11,p:0.55},
      {type:'comet',  wy:vh*0.95,xf:0.16,r:Math.min(w,h)*0.014,p:0.62},
      {type:'quasar', wy:vh*1.45,xf:0.78,r:Math.min(w,h)*0.055,p:0.5},
      {type:'earth',  wy:vh*4.55,xf:0.5, r:Math.max(w,h)*0.85,p:0.75}
    ];
  }
  build(); addEventListener('resize',build);
  addEventListener('mousemove',function(e){mx=e.clientX/innerWidth-.5;my=e.clientY/innerHeight-.5;});
  addEventListener('scroll',function(){scroll=window.scrollY||document.documentElement.scrollTop||0;},{passive:true});

  function neptune(cx,cy,r){var g=x.createRadialGradient(cx,cy,r*.6,cx,cy,r*2.6);
    g.addColorStop(0,'rgba(77,208,255,.12)');g.addColorStop(1,'rgba(77,208,255,0)');
    x.fillStyle=g;x.beginPath();x.arc(cx,cy,r*2.6,0,7);x.fill();
    g=x.createRadialGradient(cx-r*.3,cy-r*.3,r*.1,cx,cy,r);
    g.addColorStop(0,'rgba(150,215,245,.65)');g.addColorStop(.45,'rgba(55,125,185,.4)');
    g.addColorStop(1,'rgba(18,45,80,0)');
    x.fillStyle=g;x.beginPath();x.arc(cx,cy,r,0,7);x.fill();}

  function comet(cx,cy,r){var ang=-0.6,len=r*22;
    var tx2=cx+Math.cos(ang)*len,ty2=cy+Math.sin(ang)*len;
    var g=x.createLinearGradient(cx,cy,tx2,ty2);
    g.addColorStop(0,'rgba(150,225,255,.5)');g.addColorStop(.4,'rgba(90,190,255,.18)');
    g.addColorStop(1,'rgba(77,208,255,0)');
    x.save();x.strokeStyle=g;x.lineWidth=r*1.8;x.lineCap='round';
    x.beginPath();x.moveTo(cx,cy);x.lineTo(tx2,ty2);x.stroke();
    var a2=-0.42,t2x=cx+Math.cos(a2)*len*.8,t2y=cy+Math.sin(a2)*len*.8;
    var g2=x.createLinearGradient(cx,cy,t2x,t2y);
    g2.addColorStop(0,'rgba(190,240,255,.4)');g2.addColorStop(1,'rgba(120,210,255,0)');
    x.strokeStyle=g2;x.lineWidth=r*.6;x.beginPath();x.moveTo(cx,cy);x.lineTo(t2x,t2y);x.stroke();x.restore();
    g=x.createRadialGradient(cx,cy,0,cx,cy,r*2.6);
    g.addColorStop(0,'rgba(190,225,245,.55)');g.addColorStop(.35,'rgba(110,190,235,.2)');
    g.addColorStop(1,'rgba(77,208,255,0)');
    x.fillStyle=g;x.beginPath();x.arc(cx,cy,r*2.6,0,7);x.fill();
    x.fillStyle='rgba(205,230,245,.75)';x.beginPath();x.arc(cx,cy,r*.7,0,7);x.fill();}

  function quasar(cx,cy,r){var g=x.createRadialGradient(cx,cy,0,cx,cy,r*6);
    g.addColorStop(0,'rgba(180,230,255,.5)');g.addColorStop(.15,'rgba(77,208,255,.22)');
    g.addColorStop(1,'rgba(77,208,255,0)');
    x.fillStyle=g;x.beginPath();x.arc(cx,cy,r*6,0,7);x.fill();
    x.save();x.translate(cx,cy);x.rotate(-.5);x.scale(1,.32);
    g=x.createRadialGradient(0,0,r*1.1,0,0,r*3.2);
    g.addColorStop(0,'rgba(77,208,255,0)');g.addColorStop(.5,'rgba(120,220,255,.28)');
    g.addColorStop(1,'rgba(77,208,255,0)');
    x.strokeStyle=g;x.lineWidth=r*1.4;x.beginPath();x.arc(0,0,r*2.2,0,7);x.stroke();x.restore();
    x.save();x.translate(cx,cy);x.rotate(-.5+Math.PI/2);
    for(var si=0;si<2;si++){var s=si?-1:1;var jg=x.createLinearGradient(0,0,0,-r*7*s);
      jg.addColorStop(0,'rgba(180,235,255,.35)');jg.addColorStop(1,'rgba(120,210,255,0)');
      x.fillStyle=jg;x.beginPath();x.moveTo(-r*.35,0);x.lineTo(r*.35,0);
      x.lineTo(r*.9,-r*7*s);x.lineTo(-r*.9,-r*7*s);x.closePath();x.fill();}
    x.restore();
    x.fillStyle='rgba(240,250,255,.95)';x.beginPath();x.arc(cx,cy,r*.5,0,7);x.fill();
    x.strokeStyle='rgba(200,240,255,.5)';x.lineWidth=1*dpr;
    var sp=[[0,r*4.5],[Math.PI/2,r*4.5]];
    for(var k=0;k<sp.length;k++){var a=sp[k][0],l=sp[k][1];x.beginPath();
      x.moveTo(cx-Math.cos(a)*l,cy-Math.sin(a)*l);x.lineTo(cx+Math.cos(a)*l,cy+Math.sin(a)*l);x.stroke();}}

  function earth(cx,cy,r){var g=x.createRadialGradient(cx,cy,r*.98,cx,cy,r*1.15);
    g.addColorStop(0,'rgba(77,208,255,0)');g.addColorStop(.55,'rgba(80,170,230,.26)');
    g.addColorStop(1,'rgba(77,208,255,0)');
    x.fillStyle=g;x.beginPath();x.arc(cx,cy,r*1.15,0,7);x.fill();
    g=x.createRadialGradient(cx-r*.4,cy-r*.5,r*.1,cx,cy,r);
    g.addColorStop(0,'rgba(46,104,158,.9)');g.addColorStop(.5,'rgba(18,58,104,.94)');
    g.addColorStop(.82,'rgba(7,24,50,.98)');g.addColorStop(1,'rgba(4,9,20,1)');
    x.fillStyle=g;x.beginPath();x.arc(cx,cy,r,0,7);x.fill();
    x.strokeStyle='rgba(130,205,245,.4)';x.lineWidth=1.5*dpr;
    x.beginPath();x.arc(cx,cy,r,0,7);x.stroke();}

  function neb(nn,ox,oy){var g=x.createRadialGradient(nn.x+ox,nn.y+oy,0,nn.x+ox,nn.y+oy,nn.r);
    g.addColorStop(0,'rgba('+nn.col[0]+','+nn.col[1]+','+nn.col[2]+','+nn.a+')');
    g.addColorStop(.5,'rgba('+nn.col[0]+','+nn.col[1]+','+nn.col[2]+','+(nn.a*.4)+')');
    g.addColorStop(1,'rgba('+nn.col[0]+','+nn.col[1]+','+nn.col[2]+',0)');
    x.fillStyle=g;x.beginPath();x.arc(nn.x+ox,nn.y+oy,nn.r,0,7);x.fill();}

  var t=0;
  function frame(){
    x.clearRect(0,0,w,h);
    tx+=(mx-tx)*.04; ty+=(my-ty)*.04;
    tScroll+=((scroll*dpr)-tScroll)*0.08; t+=0.016;
    for(var i=0;i<nebs.length;i++){var nn=nebs[i];var oy=-tScroll*nn.p+ty*30*dpr;
      neb(nn,tx*24*dpr,oy%(h*2.4));}
    for(var b=0;b<bodies.length;b++){var bd=bodies[b];if(bd.type==='earth')continue;
      var sy=bd.wy-tScroll*bd.p+ty*14*dpr;var sx=w*bd.xf+tx*26*dpr*(1-bd.p);var margin=bd.r*7;
      if(sy>-margin&&sy<h+margin){
        if(bd.type==='neptune')neptune(sx,sy,bd.r);
        else if(bd.type==='quasar')quasar(sx,sy,bd.r);
        else if(bd.type==='comet')comet(sx,sy,bd.r);}}
    var eb=bodies[3];
    var docPx=(document.documentElement.scrollHeight-innerHeight)*dpr||1;
    var pe=Math.min(1,Math.max(0,(tScroll/docPx-0.55)/0.45));
    if(pe>0){var rise=eb.r*0.78*pe;earth(w*0.5,h+eb.r-rise,eb.r);}
    for(var s2=0;s2<stars.length;s2++){var st=stars[s2];
      var stx=st.x+tx*st.depth*70*dpr;
      var sty=st.y-tScroll*(0.25+st.depth*0.5)+ty*70*dpr;
      sty=((sty%(h*2.2))+(h*2.2))%(h*2.2);
      if(sty>h)continue;
      var a=st.base; if(!reduce)a=st.base*(0.55+0.45*Math.sin(t*st.tws+st.tw));
      x.globalAlpha=Math.max(0,Math.min(1,a));
      x.fillStyle=st.cyan?'#7FDBFF':'#EAF4FA';
      x.beginPath();x.arc(stx,sty,st.r,0,7);x.fill();
      if(st.depth>0.85){x.globalAlpha=a*0.22;x.beginPath();x.arc(stx,sty,st.r*3,0,7);x.fill();}}
    x.globalAlpha=1;
    requestAnimationFrame(frame);
  }
  frame();
})();